import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=1b61efc4&scoped=true&"
import script from "./setup.vue?vue&type=script&lang=js&"
export * from "./setup.vue?vue&type=script&lang=js&"
import style0 from "./setup.vue?vue&type=style&index=0&id=1b61efc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b61efc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b61efc4')) {
      api.createRecord('1b61efc4', component.options)
    } else {
      api.reload('1b61efc4', component.options)
    }
    module.hot.accept("./setup.vue?vue&type=template&id=1b61efc4&scoped=true&", function () {
      api.rerender('1b61efc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecommerce/setup.vue"
export default component.exports